/* eslint-disable */
// ─────────────────────────────────────────────────────────────────────────────
// LegalLayout.jsx — layout compartilhado das páginas legais IMOBMEET
// Transcrição fiel do componente `ll` do bundle de produção des-minificado.
// Usado por Política de Privacidade, Portal LGPD e Termos de Uso.
// O wrapper original ($r) é substituído por Navbar + conteúdo + Footer.
// ─────────────────────────────────────────────────────────────────────────────
import * as b from "react";
import * as n from "react/jsx-runtime";
import { Link as V } from "react-router-dom";
import { C, font, mono } from "../tokens";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Aliases dos identificadores do bundle original.
const s = C, p = font, Pt = mono;
const _n = Navbar;   // Navbar compartilhada
const Hn = Footer;   // Footer compartilhado

// Slug para âncoras (Od no bundle original).
const Od = e => e.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Wrapper de revelação por scroll (k no bundle original).
function k({
    children: e,
    delay: t = 0,
    as: r = "div",
    style: o = {},
    className: i = "",
    ...a
}) {
    const l = b.useRef(null);
    b.useEffect(() => {
        const c = l.current;
        if (!c) return;
        const u = new IntersectionObserver(([m]) => {
            m.isIntersecting && (c.classList.add("is-in"), u.disconnect())
        }, {
            threshold: .12,
            rootMargin: "0px 0px -8% 0px"
        });
        return u.observe(c), () => u.disconnect()
    }, []);
    const d = t ? ` delay-${t}` : "";
    return n.jsx(r, {
        ref: l,
        className: `reveal${d} ${i}`,
        style: o,
        ...a,
        children: e
    })
}

export default function LegalLayout({
    eyebrow: e,
    title: t,
    updated: r,
    intro: o,
    sections: i = []
}) {
    return n.jsxs(n.Fragment, {
        children: [n.jsx(_n, {}), n.jsxs("section", {
            style: {
                position: "relative",
                overflow: "hidden",
                background: "linear-gradient(135deg, #0B1733 0%, #0A1230 100%)",
                padding: "56px 28px 48px"
            },
            children: [n.jsx("div", {
                className: "grid-bg",
                style: {
                    position: "absolute",
                    inset: 0,
                    opacity: .25,
                    pointerEvents: "none"
                }
            }), n.jsx("div", {
                style: {
                    position: "absolute",
                    top: -80,
                    right: -60,
                    width: 360,
                    height: 360,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(5,96,255,0.30), transparent 65%)",
                    filter: "blur(20px)",
                    pointerEvents: "none"
                }
            }), n.jsxs("div", {
                style: {
                    maxWidth: 880,
                    margin: "0 auto",
                    position: "relative"
                },
                children: [n.jsx(k, {
                    children: n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 12.5,
                            fontWeight: 800,
                            letterSpacing: 1.4,
                            textTransform: "uppercase",
                            color: "#8FB3E6",
                            marginBottom: 14
                        },
                        children: e
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsx("h1", {
                        style: {
                            fontFamily: p,
                            fontSize: "clamp(32px, 4.6vw, 46px)",
                            fontWeight: 800,
                            lineHeight: 1.05,
                            letterSpacing: -1.2,
                            color: "#FFFFFF",
                            margin: "0 0 14px"
                        },
                        children: t
                    })
                }), n.jsx(k, {
                    delay: 2,
                    children: n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 16,
                            lineHeight: 1.6,
                            color: "rgba(255,255,255,0.78)",
                            margin: 0,
                            maxWidth: 700
                        },
                        children: o
                    })
                })]
            })]
        }), n.jsx("section", {
            style: {
                background: s.bgAlt,
                padding: "44px 28px 88px"
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 880,
                    margin: "0 auto"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        marginBottom: 24,
                        fontFamily: p,
                        fontSize: 13.5,
                        color: s.muted
                    },
                    children: [n.jsxs("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: s.accent,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("circle", {
                            cx: "12",
                            cy: "12",
                            r: "9"
                        }), n.jsx("path", {
                            d: "M12 7v5l3 2"
                        })]
                    }), "Última atualização: ", n.jsx("strong", {
                        style: {
                            color: s.text,
                            fontWeight: 700
                        },
                        children: r
                    })]
                }), n.jsxs("div", {
                    style: {
                        background: s.surface,
                        border: `1px solid ${s.border}`,
                        borderRadius: 16,
                        padding: "22px 24px",
                        marginBottom: 28,
                        boxShadow: "0 10px 30px rgba(10,15,30,0.05)"
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 12,
                            fontWeight: 800,
                            letterSpacing: .6,
                            textTransform: "uppercase",
                            color: s.muted,
                            marginBottom: 14
                        },
                        children: "Conteúdo desta página"
                    }), n.jsx("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                            gap: "10px 28px"
                        },
                        children: i.map(a => n.jsxs("a", {
                            href: `#${Od(a.title)}`,
                            style: {
                                fontFamily: p,
                                fontSize: 14.5,
                                color: s.text,
                                textDecoration: "none",
                                lineHeight: 1.4,
                                display: "flex",
                                alignItems: "baseline",
                                gap: 9,
                                transition: "color 0.15s"
                            },
                            onMouseEnter: l => {
                                l.currentTarget.style.color = s.accent
                            },
                            onMouseLeave: l => {
                                l.currentTarget.style.color = s.text
                            },
                            children: [n.jsx("span", {
                                style: {
                                    width: 5,
                                    height: 5,
                                    borderRadius: 2,
                                    background: s.accent,
                                    flexShrink: 0,
                                    transform: "translateY(-2px)"
                                }
                            }), a.title]
                        }, a.title))
                    })]
                }), i.map(a => n.jsxs("div", {
                    id: Od(a.title),
                    style: {
                        scrollMarginTop: 90,
                        marginBottom: 16,
                        background: s.surface,
                        border: `1px solid ${s.border}`,
                        borderRadius: 16,
                        padding: "28px 30px",
                        boxShadow: "0 8px 24px rgba(10,15,30,0.04)"
                    },
                    children: [n.jsx("h2", {
                        style: {
                            fontFamily: p,
                            fontSize: 21,
                            fontWeight: 800,
                            letterSpacing: -.4,
                            color: s.text,
                            margin: "0 0 14px"
                        },
                        children: a.title
                    }), (a.paragraphs || []).map((l, d) => n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 15.5,
                            lineHeight: 1.75,
                            color: s.muted,
                            margin: "0 0 12px"
                        },
                        children: l
                    }, d)), a.bullets && n.jsx("ul", {
                        style: {
                            margin: "4px 0 0",
                            paddingLeft: 0,
                            listStyle: "none"
                        },
                        children: a.bullets.map((l, d) => n.jsxs("li", {
                            style: {
                                position: "relative",
                                paddingLeft: 26,
                                marginBottom: 10,
                                fontFamily: p,
                                fontSize: 15.5,
                                lineHeight: 1.7,
                                color: s.muted
                            },
                            children: [n.jsx("span", {
                                style: {
                                    position: "absolute",
                                    left: 2,
                                    top: 9,
                                    width: 7,
                                    height: 7,
                                    borderRadius: 2,
                                    background: s.accent
                                }
                            }), l]
                        }, d))
                    })]
                }, a.title)), n.jsxs("div", {
                    style: {
                        marginTop: 24,
                        padding: "26px 30px",
                        borderRadius: 16,
                        background: "linear-gradient(135deg, #0B1733 0%, #0A1230 100%)",
                        color: "#FFFFFF"
                    },
                    children: [n.jsx("h2", {
                        style: {
                            fontFamily: p,
                            fontSize: 18,
                            fontWeight: 800,
                            margin: "0 0 8px"
                        },
                        children: "Ficou com alguma dúvida?"
                    }), n.jsxs("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 14.5,
                            lineHeight: 1.65,
                            color: "rgba(255,255,255,0.8)",
                            margin: 0
                        },
                        children: ["Fale com nossa equipe pelo e-mail", " ", n.jsx("a", {
                            href: "mailto:privacidade@imobmeet.com.br",
                            style: {
                                color: "#8FB3E6",
                                fontWeight: 700
                            },
                            children: "privacidade@imobmeet.com.br"
                        }), ". Este documento pode ser atualizado para refletir mudanças em nossos serviços ou na legislação aplicável; recomendamos revisá-lo periodicamente."]
                    })]
                })]
            })
        }), n.jsx(Hn, {})]
    })
}
